import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex justify-content-between align-items-center w-full mb-5" }
const _hoisted_2 = { class: "font-semibold text-xl" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-column"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_settings" }, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "flex flex-column pt-2 h-full"
}
const _hoisted_6 = { class: "flex gap-4 mb-4" }
const _hoisted_7 = { class: "font-semibold" }
const _hoisted_8 = { class: "flex flex-column gap-2 pb-4" }
const _hoisted_9 = { class: "font-semibold" }
const _hoisted_10 = { class: "flex flex-wrap gap-2" }
const _hoisted_11 = { class: "flex gap-4 surface-100 w-fit px-2 py-1 border-round-xl" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "h-full border-1 border-transparent border-round-2xl overflow-hidden"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MapCustom = _resolveComponent("MapCustom")!

  return (_openBlock(), _createElementBlock("div", {
    tabindex: "1",
    class: "flex flex-column bg-white border-round-3xl border-1 border-300 p-4 w-20rem sm:w-25rem h-28rem cursor-pointer",
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'StationById', params: { id: _ctx.externalId } }))),
    onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (
      _ctx.$router.push({ name: 'StationById', params: { id: _ctx.externalId } })
    ), ["enter"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("widgets.public-transport.title")), 1),
      (_ctx.user)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "icon-warpit_icon_settings text-2xl",
            tabindex: "1",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('edit')), ["stop"])),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('edit')), ["stop"]), ["enter"]))
          }, null, 32))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.externalId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("widgets.not_configured")), 1),
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("widgets.configure")) + " ", 1),
            _hoisted_4,
            _createTextVNode(".")
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("widgets.public-transport.station")), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.payload.name), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("widgets.public-transport.arrivals")), 1),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrivals, (arrival, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", null, [
                      (_ctx.calculateArrivalTime(arrival.arrival_time).hours > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.calculateArrivalTime(arrival.arrival_time).hours) + " h ", 1))
                        : _createCommentVNode("", true),
                      _createTextVNode(_toDisplayString(_ctx.calculateArrivalTime(arrival.arrival_time).minutes) + " min", 1)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          (_ctx.marker !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_MapCustom, {
                  center: _ctx.marker.position,
                  markers: [_ctx.marker],
                  options: {
            zoomControl: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            disableDefaultUi: false,
            clickableIcons: false,
          }
                }, null, 8, ["center", "markers"])
              ]))
            : _createCommentVNode("", true)
        ]))
  ], 32))
}